import React from 'react';
import { motion } from 'framer-motion';
import { CARD } from '../../config/designTokens';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  hoverEffect = false
}: CardProps) {
  return <motion.div className={`
        ${CARD.base} overflow-hidden
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} whileHover={hoverEffect && onClick ? {
    y: -4,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    borderColor: CARD.hoverBorder
  } : {}} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 25,
    duration: 0.2
  }} data-id="element-2255">
      {children}
    </motion.div>;
}